(() => {

  const section = document.querySelector('.feature-explorer');
  if (!section) return;

  const content = section.querySelector('.feature-explorer__content');
  const overlay = section.querySelector('[data-content-overlay]');
  const viewButtons = section.querySelectorAll('[data-view-button]');

  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;

  const open = () => {
    content.classList.add('is-open');
    overlay.classList.add('is-active');
    document.body.classList.add('has-feature-open');
  };

  const close = () => {
    content.classList.remove('is-open');
    overlay.classList.remove('is-active');
    document.body.classList.remove('has-feature-open');
  };

  const activate = (view, index) => {

    section.querySelectorAll('.feature-explorer__view')
      .forEach(el => el.classList.toggle('is-active', el.dataset.view === view));

    section.querySelectorAll('.feature-explorer__view-btn')
      .forEach(el => el.classList.toggle('is-active', el.dataset.viewButton === view));

    section.querySelectorAll('.feature-explorer__hotspot')
      .forEach(el => el.classList.toggle('is-active', el.dataset.featureTrigger === `${view}-${index}`));

    section.querySelectorAll('.feature-explorer__panel')
      .forEach(el => el.classList.toggle('is-active', el.dataset.panel === `${view}-${index}`));

    section.querySelectorAll('.feature-explorer__tab')
      .forEach(el => el.classList.toggle('is-active', el.dataset.tab === `${view}-${index}`));

  };

  overlay.addEventListener('click', close);
  section.querySelector('.feature-explorer__mobile-close')?.addEventListener('click', close);

  viewButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const view = btn.dataset.viewButton;
      activate(view, 0);
    });
  });

  section.querySelectorAll('.feature-explorer__hotspot').forEach(el => {
    el.addEventListener('click', () => {
      const [view, i] = el.dataset.featureTrigger.split('-');
      activate(view, Number(i));
      if (isMobile()) open();
    });
  });

  section.querySelectorAll('.feature-explorer__tab').forEach(el => {
    el.addEventListener('click', () => {
      const [view, i] = el.dataset.tab.split('-');
      activate(view, Number(i));
    });
  });

  section.querySelectorAll('.feature-explorer__arrow').forEach(btn => {
    btn.addEventListener('click', () => {

      const tabs = [...section.querySelectorAll('.feature-explorer__tab')];

      let i = tabs.findIndex(t => t.classList.contains('is-active'));

      i += btn.dataset.arrow === 'next' ? 1 : -1;

      if (i < 0) i = tabs.length - 1;
      if (i >= tabs.length) i = 0;

      const [view, index] = tabs[i].dataset.tab.split('-');
      activate(view, Number(index));

    });
  });

  
  let startX = 0;
  let startY = 0;

  const swipeArea = section;

  swipeArea.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  swipeArea.addEventListener('touchend', e => {

    const diffX = e.changedTouches[0].clientX - startX;
    const diffY = e.changedTouches[0].clientY - startY;

    // Ignore vertical scrolling
    if (Math.abs(diffY) > Math.abs(diffX)) return;

    // Minimum swipe distance
    if (Math.abs(diffX) < 40) return;

    const arrow = diffX < 0 ? 'next' : 'prev';

    section
      .querySelector(`[data-arrow="${arrow}"]`)
      ?.click();

  }, { passive: true });
  

})();